export const figmaPrimitives = {
  brand: {
    50: '#F7FFFF',
    100: '#EAF7F3',
    200: '#CFEEE7',
    300: '#B8EDE0',
    400: '#7BD6BF',
    500: '#3DD5AE',
    600: '#22BD95',
    700: '#179574',
    800: '#0E614C',
    900: '#073529',
  },
  location: {
    50: '#F3FBFF',
    100: '#E6F3F7',
    200: '#C5E4F2',
    300: '#9CD7EF',
    400: '#61C8EF',
    500: '#00A2E1',
    600: '#007DAE',
    700: '#00597B',
    800: '#002C3E',
    900: '#00121A',
  },
  teal: {
    50: '#F8F9F9',
    100: '#EDF2F3',
    200: '#D5E4E7',
    300: '#AED4DB',
    400: '#7DC8D4',
    500: '#2EABBF',
    600: '#20899A',
    700: '#156572',
    800: '#0A383F',
    900: '#031416',
  },
  purple: {
    50: '#F7F7FF',
    100: '#E9E4F9',
    200: '#D3CAF0',
    300: '#B9AAE2',
    400: '#9681D0',
    500: '#6B48CB',
    600: '#512DB3',
    700: '#3D208D',
    800: '#27135C',
    900: '#00121A',
  },
  pink: {
    50: '#FFF0FF',
    100: '#FFD8F7',
    200: '#E8BEE2',
    300: '#ECA0E1',
    400: '#CB6FBF',
    500: '#A93A9A',
    600: '#862A7A',
    700: '#611C58',
    800: '#320E2D',
    900: '#140512',
  },
  green: {
    50: '#F9FFED',
    100: '#F0FFE0',
    200: '#E4FFCA',
    300: '#C2EA97',
    400: '#A0D468',
    500: '#6EB522',
    600: '#548F15',
    700: '#3A640D',
    800: '#1B2F05',
    900: '#00121A',
  },
  orange: {
    50: '#FFF4E3',
    100: '#FFE5CB',
    200: '#FFD5AC',
    300: '#F9B46B',
    400: '#EF963B',
    500: '#D17F2A',
    600: '#AC651C',
    700: '#834C12',
    800: '#4E2D0A',
    900: '#211304',
  },
  red: {
    50: '#FFEEEE',
    100: '#FFD0D0',
    200: '#FFB0B0',
    300: '#FF7E81',
    400: '#E85152',
    500: '#CD3134',
    600: '#A92225',
    700: '#811719',
    800: '#4E0D0E',
    900: '#230506',
  },
  neutral: {
    0: '#FFFFFF',
    50: '#FBFCFB',
    100: '#F4F6F5',
    200: '#ECEFEE',
    300: '#E4E7E6',
    400: '#CFD3D2',
    500: '#AAB1AF',
    600: '#848B89',
    700: '#636967',
    800: '#424846',
    850: '#292E2C',
    900: '#1F2322',
    950: '#181B1A',
    1000: '#0F1211',
  },
} as const

type FigmaRamp = { 100: string; 300: string; 400: string; 500: string; 700: string; 800: string }

export const toDarkShades = (ramp: FigmaRamp) => ({
  darkest: ramp[300],
  dark: ramp[400],
  main: ramp[500],
  light: ramp[700],
  lightest: ramp[800],
})
